var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackgroundVectors(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1020,
    viewBox: "0 0 1920 1020",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1828.45 704.08C1827.84 704.74 1827.19 705.38 1826.53 705.99L1922.6 791.26C1922.45 790.03 1922.42 788.79 1922.52 787.57L1828.45 704.08Z",
    fill: "url(#paint0_linear_3572_6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1242.28 183.839L1067.67 28.8691C1066.78 29.0091 1065.87 29.0891 1064.96 29.0891C1064.56 29.0891 1064.16 29.0491 1063.77 29.0291L1240.32 185.719C1240.95 185.069 1241.6 184.439 1242.28 183.849V183.839Z",
    fill: "url(#paint1_linear_3572_6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.22 999.32C413.22 999.32 414.18 999.42 415.13 999.57L-83.32 558.43C-83.86 559.01 -84.43 559.57 -85.03 560.1L411.28 999.35C411.59 999.33 411.9 999.32 412.21 999.32H412.22Z",
    fill: "url(#paint2_linear_3572_6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.81 999.85L1272.95 29.6502C1271.18 29.7302 1269.39 29.5702 1267.6 29.1602L636.63 999.09C638.38 999.26 640.1 999.52 641.8 999.85H641.81Z",
    fill: "url(#paint3_linear_3572_6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.52 73.6599L271.88 30.6699C270.73 31.1499 269.56 31.5799 268.37 31.9499L285.62 73.9899C286.92 73.8399 288.23 73.7299 289.53 73.6699L289.52 73.6599Z",
    fill: "url(#paint4_linear_3572_6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.48 999.529L483.21 584.619C482.01 584.969 480.79 585.269 479.54 585.519L649.45 999.539C650.79 999.539 652.14 999.539 653.48 999.529Z",
    fill: "url(#paint5_linear_3572_6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1608.33 115.649C1609.11 115.619 1609.88 115.629 1610.64 115.659L1607.02 31.6191C1605.91 31.9691 1604.79 32.2591 1603.68 32.4891L1607.26 115.729C1607.61 115.699 1607.97 115.669 1608.32 115.659L1608.33 115.649Z",
    fill: "url(#paint6_linear_3572_6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1635.91 781.01L1645.68 1007.96H1649.05L1639.3 781.33C1638.17 781.28 1637.04 781.18 1635.91 781.02V781.01Z",
    fill: "url(#paint7_linear_3572_6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.6 26.4994L912.59 207.519C913.47 208.169 914.31 208.869 915.13 209.609L1112.12 24.8594C1109.94 25.6094 1107.78 26.1694 1105.6 26.4994Z",
    fill: "url(#paint8_linear_3572_6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.08 999.4L539.97 600.54C539.15 599.77 538.38 598.95 537.65 598.1L110.87 998.73C112.29 998.88 113.7 999.1 115.09 999.39L115.08 999.4Z",
    fill: "url(#paint9_linear_3572_6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1139.01 276.361L829.83 33.3906C827.68 33.7706 825.51 34.0606 823.31 34.2506L1136.82 280.621C1137.44 279.141 1138.17 277.721 1139.02 276.361H1139.01Z",
    fill: "url(#paint10_linear_3572_6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1723.71 735.84C1722.92 737.2 1722.02 738.49 1721.03 739.72L1950.68 920.18C1952.46 919.58 1954.32 919.04 1956.24 918.56L1723.71 735.83V735.84Z",
    fill: "url(#paint11_linear_3572_6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.41 346.99L1033.12 30.3398C1031.85 31.4198 1030.55 32.4199 1029.21 33.3199L1095.24 348.71C1096.59 348.04 1097.99 347.47 1099.42 346.99H1099.41Z",
    fill: "url(#paint12_linear_3572_6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1182.87 745.63C1181.29 745.61 1179.75 745.48 1178.25 745.23L1231.55 999.831C1232.97 999.321 1234.4 998.941 1235.85 998.701L1182.87 745.63Z",
    fill: "url(#paint13_linear_3572_6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.52 58.34L-23.79 12C-23.66 13.27 -23.57 14.57 -23.5 15.89L44.07 62.41C43.88 61.05 43.7 59.69 43.52 58.34Z",
    fill: "url(#paint14_linear_3572_6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.12 998.221L504.6 634.241C502.59 634.191 500.59 634.121 498.58 634.051L992.62 999.901C993.75 999.271 994.92 998.711 996.12 998.221Z",
    fill: "url(#paint15_linear_3572_6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1778.86 219.35L1920.2 36.4098L1919.61 27.3398L1774.2 215.54C1775.79 216.73 1777.35 218 1778.86 219.35Z",
    fill: "url(#paint16_linear_3572_6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200.93 841.609L921.13 945.199C921.62 946.069 922.22 947.239 922.69 948.279L1200.1 845.569C1200.32 844.279 1200.6 842.959 1200.93 841.609Z",
    fill: "url(#paint17_linear_3572_6)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1301.29 705.301C1303.78 705.301 1305.79 703.286 1305.79 700.801C1305.79 698.315 1303.78 696.301 1301.29 696.301C1298.8 696.301 1296.79 698.315 1296.79 700.801C1296.79 703.286 1298.8 705.301 1301.29 705.301Z",
    fill: "#8FFFFC"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1425.9 691.34C1428.39 691.34 1430.4 689.325 1430.4 686.84C1430.4 684.355 1428.39 682.34 1425.9 682.34C1423.41 682.34 1421.4 684.355 1421.4 686.84C1421.4 689.325 1423.41 691.34 1425.9 691.34Z",
    fill: "#8FFFFC"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1548.02 695.98C1550.51 695.98 1552.52 693.966 1552.52 691.48C1552.52 688.995 1550.51 686.98 1548.02 686.98C1545.53 686.98 1543.52 688.995 1543.52 691.48C1543.52 693.966 1545.53 695.98 1548.02 695.98Z",
    fill: "#8FFFFC"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1564.13 706.439C1566.62 706.439 1568.63 704.425 1568.63 701.939C1568.63 699.454 1566.62 697.439 1564.13 697.439C1561.64 697.439 1559.63 699.454 1559.63 701.939C1559.63 704.425 1561.64 706.439 1564.13 706.439Z",
    fill: "#8FFFFC"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1671.43 703.24C1673.92 703.24 1675.93 701.226 1675.93 698.74C1675.93 696.255 1673.92 694.24 1671.43 694.24C1668.94 694.24 1666.93 696.255 1666.93 698.74C1666.93 701.226 1668.94 703.24 1671.43 703.24Z",
    fill: "#8FFFFC"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1636.38 688.041C1638.87 688.041 1640.88 686.026 1640.88 683.541C1640.88 681.056 1638.87 679.041 1636.38 679.041C1633.89 679.041 1631.88 681.056 1631.88 683.541C1631.88 686.026 1633.89 688.041 1636.38 688.041Z",
    fill: "#8FFFFC"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1694.38 713.33C1696.87 713.33 1698.88 711.315 1698.88 708.83C1698.88 706.345 1696.87 704.33 1694.38 704.33C1691.89 704.33 1689.88 706.345 1689.88 708.83C1689.88 711.315 1691.89 713.33 1694.38 713.33Z",
    fill: "#8FFFFC"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M754.44 824.471C756.925 824.471 758.94 822.456 758.94 819.971C758.94 817.485 756.925 815.471 754.44 815.471C751.955 815.471 749.94 817.485 749.94 819.971C749.94 822.456 751.955 824.471 754.44 824.471Z",
    fill: "#8FFFFC"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M924.25 951.02C926.735 951.02 928.75 949.005 928.75 946.52C928.75 944.034 926.735 942.02 924.25 942.02C921.765 942.02 919.75 944.034 919.75 946.52C919.75 949.005 921.765 951.02 924.25 951.02Z",
    fill: "#8FFFFC"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1200.87 847.48C1203.36 847.48 1205.37 845.466 1205.37 842.98C1205.37 840.495 1203.36 838.48 1200.87 838.48C1198.38 838.48 1196.37 840.495 1196.37 842.98C1196.37 845.466 1198.38 847.48 1200.87 847.48Z",
    fill: "#8FFFFC"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M994.77 1003.87C997.255 1003.87 999.27 1001.86 999.27 999.371C999.27 996.886 997.255 994.871 994.77 994.871C992.285 994.871 990.27 996.886 990.27 999.371C990.27 1001.86 992.285 1003.87 994.77 1003.87Z",
    fill: "#8FFFFC"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1233.21 1003.23C1235.7 1003.23 1237.71 1001.22 1237.71 998.73C1237.71 996.245 1235.7 994.23 1233.21 994.23C1230.72 994.23 1228.71 996.245 1228.71 998.73C1228.71 1001.22 1230.72 1003.23 1233.21 1003.23Z",
    fill: "#8FFFFC"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1180.93 749.211C1183.42 749.211 1185.43 747.196 1185.43 744.711C1185.43 742.226 1183.42 740.211 1180.93 740.211C1178.44 740.211 1176.43 742.226 1176.43 744.711C1176.43 747.196 1178.44 749.211 1180.93 749.211Z",
    fill: "#8FFFFC"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M647.14 991.9C649.625 991.9 651.64 989.886 651.64 987.4C651.64 984.915 649.625 982.9 647.14 982.9C644.655 982.9 642.64 984.915 642.64 987.4C642.64 989.886 644.655 991.9 647.14 991.9Z",
    fill: "#8FFFFC"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M501.56 638.791C504.045 638.791 506.06 636.776 506.06 634.291C506.06 631.806 504.045 629.791 501.56 629.791C499.075 629.791 497.06 631.806 497.06 634.291C497.06 636.776 499.075 638.791 501.56 638.791Z",
    fill: "#8FFFFC"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.06 866.77C260.545 866.77 262.56 864.755 262.56 862.27C262.56 859.784 260.545 857.77 258.06 857.77C255.575 857.77 253.56 859.784 253.56 862.27C253.56 864.755 255.575 866.77 258.06 866.77Z",
    fill: "#8FFFFC"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M913.85 213.52C916.335 213.52 918.35 211.505 918.35 209.02C918.35 206.534 916.335 204.52 913.85 204.52C911.365 204.52 909.35 206.534 909.35 209.02C909.35 211.505 911.365 213.52 913.85 213.52Z",
    fill: "#8FFFFC"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1096.65 352.24C1099.14 352.24 1101.15 350.226 1101.15 347.74C1101.15 345.255 1099.14 343.24 1096.65 343.24C1094.16 343.24 1092.15 345.255 1092.15 347.74C1092.15 350.226 1094.16 352.24 1096.65 352.24Z",
    fill: "#8FFFFC"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1139.34 283.311C1141.83 283.311 1143.84 281.296 1143.84 278.811C1143.84 276.325 1141.83 274.311 1139.34 274.311C1136.85 274.311 1134.84 276.325 1134.84 278.811C1134.84 281.296 1136.85 283.311 1139.34 283.311Z",
    fill: "#8FFFFC"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1071.74 230.52C1074.23 230.52 1076.24 228.505 1076.24 226.02C1076.24 223.534 1074.23 221.52 1071.74 221.52C1069.25 221.52 1067.24 223.534 1067.24 226.02C1067.24 228.505 1069.25 230.52 1071.74 230.52Z",
    fill: "#8FFFFC"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M975.29 155.65C977.775 155.65 979.79 153.636 979.79 151.15C979.79 148.665 977.775 146.65 975.29 146.65C972.805 146.65 970.79 148.665 970.79 151.15C970.79 153.636 972.805 155.65 975.29 155.65Z",
    fill: "#8FFFFC"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1086.2 50.8711C1088.69 50.8711 1090.7 48.8564 1090.7 46.3711C1090.7 43.8858 1088.69 41.8711 1086.2 41.8711C1083.71 41.8711 1081.7 43.8858 1081.7 46.3711C1081.7 48.8564 1083.71 50.8711 1086.2 50.8711Z",
    fill: "#8FFFFC"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1195.87 147.68C1198.36 147.68 1200.37 145.665 1200.37 143.18C1200.37 140.694 1198.36 138.68 1195.87 138.68C1193.38 138.68 1191.37 140.694 1191.37 143.18C1191.37 145.665 1193.38 147.68 1195.87 147.68Z",
    fill: "#8FFFFC"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1042.74 91.75C1045.23 91.75 1047.24 89.7353 1047.24 87.25C1047.24 84.7647 1045.23 82.75 1042.74 82.75C1040.25 82.75 1038.24 84.7647 1038.24 87.25C1038.24 89.7353 1040.25 91.75 1042.74 91.75Z",
    fill: "#8FFFFC"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M827.48 39.9199C829.965 39.9199 831.98 37.9052 831.98 35.4199C831.98 32.9346 829.965 30.9199 827.48 30.9199C824.995 30.9199 822.98 32.9346 822.98 35.4199C822.98 37.9052 824.995 39.9199 827.48 39.9199Z",
    fill: "#8FFFFC"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1030.97 36.3301C1033.46 36.3301 1035.47 34.3154 1035.47 31.8301C1035.47 29.3448 1033.46 27.3301 1030.97 27.3301C1028.48 27.3301 1026.47 29.3448 1026.47 31.8301C1026.47 34.3154 1028.48 36.3301 1030.97 36.3301Z",
    fill: "#8FFFFC"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter27_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1067.01 33.9707C1069.5 33.9707 1071.51 31.956 1071.51 29.4707C1071.51 26.9854 1069.5 24.9707 1067.01 24.9707C1064.52 24.9707 1062.51 26.9854 1062.51 29.4707C1062.51 31.956 1064.52 33.9707 1067.01 33.9707Z",
    fill: "#8FFFFC"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter28_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1108.42 30.4609C1110.91 30.4609 1112.92 28.4462 1112.92 25.9609C1112.92 23.4757 1110.91 21.4609 1108.42 21.4609C1105.93 21.4609 1103.92 23.4757 1103.92 25.9609C1103.92 28.4462 1105.93 30.4609 1108.42 30.4609Z",
    fill: "#8FFFFC"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter29_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1269.48 34.9297C1271.97 34.9297 1273.98 32.915 1273.98 30.4297C1273.98 27.9444 1271.97 25.9297 1269.48 25.9297C1266.99 25.9297 1264.98 27.9444 1264.98 30.4297C1264.98 32.915 1266.99 34.9297 1269.48 34.9297Z",
    fill: "#8FFFFC"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter30_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1242.23 189.76C1244.72 189.76 1246.73 187.745 1246.73 185.26C1246.73 182.774 1244.72 180.76 1242.23 180.76C1239.74 180.76 1237.73 182.774 1237.73 185.26C1237.73 187.745 1239.74 189.76 1242.23 189.76Z",
    fill: "#8FFFFC"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter31_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.8101 64.9297C46.2953 64.9297 48.3101 62.915 48.3101 60.4297C48.3101 57.9444 46.2953 55.9297 43.8101 55.9297C41.3248 55.9297 39.3101 57.9444 39.3101 60.4297C39.3101 62.915 41.3248 64.9297 43.8101 64.9297Z",
    fill: "#8FFFFC"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter32_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.3999 36.9004C6.88518 36.9004 8.8999 34.8857 8.8999 32.4004C8.8999 29.9151 6.88518 27.9004 4.3999 27.9004C1.91462 27.9004 -0.100098 29.9151 -0.100098 32.4004C-0.100098 34.8857 1.91462 36.9004 4.3999 36.9004Z",
    fill: "#8FFFFC"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter33_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.04 35.1895C272.525 35.1895 274.54 33.1747 274.54 30.6895C274.54 28.2042 272.525 26.1895 270.04 26.1895C267.555 26.1895 265.54 28.2042 265.54 30.6895C265.54 33.1747 267.555 35.1895 270.04 35.1895Z",
    fill: "#8FFFFC"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter34_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.62 78.3809C290.105 78.3809 292.12 76.3661 292.12 73.8809C292.12 71.3956 290.105 69.3809 287.62 69.3809C285.135 69.3809 283.12 71.3956 283.12 73.8809C283.12 76.3661 285.135 78.3809 287.62 78.3809Z",
    fill: "#8FFFFC"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter35_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.98999 641.121C6.47527 641.121 8.48999 639.106 8.48999 636.621C8.48999 634.136 6.47527 632.121 3.98999 632.121C1.50471 632.121 -0.51001 634.136 -0.51001 636.621C-0.51001 639.106 1.50471 641.121 3.98999 641.121Z",
    fill: "#8FFFFC"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter36_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.46 1004.7C415.945 1004.7 417.96 1002.68 417.96 1000.2C417.96 997.714 415.945 995.699 413.46 995.699C410.975 995.699 408.96 997.714 408.96 1000.2C408.96 1002.68 410.975 1004.7 413.46 1004.7Z",
    fill: "#8FFFFC"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter37_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.16 1005.23C114.645 1005.23 116.66 1003.22 116.66 1000.73C116.66 998.245 114.645 996.23 112.16 996.23C109.675 996.23 107.66 998.245 107.66 1000.73C107.66 1003.22 109.675 1005.23 112.16 1005.23Z",
    fill: "#8FFFFC"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter38_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1605.34 37.9492C1607.83 37.9492 1609.84 35.9345 1609.84 33.4492C1609.84 30.9639 1607.83 28.9492 1605.34 28.9492C1602.85 28.9492 1600.84 30.9639 1600.84 33.4492C1600.84 35.9345 1602.85 37.9492 1605.34 37.9492Z",
    fill: "#8FFFFC"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter39_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1609.35 120.49C1611.84 120.49 1613.85 118.476 1613.85 115.99C1613.85 113.505 1611.84 111.49 1609.35 111.49C1606.86 111.49 1604.85 113.505 1604.85 115.99C1604.85 118.476 1606.86 120.49 1609.35 120.49Z",
    fill: "#8FFFFC"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter40_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1916.86 38.9297C1919.35 38.9297 1921.36 36.915 1921.36 34.4297C1921.36 31.9444 1919.35 29.9297 1916.86 29.9297C1914.37 29.9297 1912.36 31.9444 1912.36 34.4297C1912.36 36.915 1914.37 38.9297 1916.86 38.9297Z",
    fill: "#8FFFFC"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter41_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1775.47 222.791C1777.96 222.791 1779.97 220.776 1779.97 218.291C1779.97 215.806 1777.96 213.791 1775.47 213.791C1772.98 213.791 1770.97 215.806 1770.97 218.291C1770.97 220.776 1772.98 222.791 1775.47 222.791Z",
    fill: "#8FFFFC"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter42_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1637.74 785.779C1640.23 785.779 1642.24 783.765 1642.24 781.279C1642.24 778.794 1640.23 776.779 1637.74 776.779C1635.25 776.779 1633.24 778.794 1633.24 781.279C1633.24 783.765 1635.25 785.779 1637.74 785.779Z",
    fill: "#8FFFFC"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter43_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1647.3 1009.7C1649.79 1009.7 1651.8 1007.68 1651.8 1005.2C1651.8 1002.71 1649.79 1000.7 1647.3 1000.7C1644.81 1000.7 1642.8 1002.71 1642.8 1005.2C1642.8 1007.68 1644.81 1009.7 1647.3 1009.7Z",
    fill: "#8FFFFC"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter44_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1914.5 893.881C1916.99 893.881 1919 891.866 1919 889.381C1919 886.896 1916.99 884.881 1914.5 884.881C1912.01 884.881 1910 886.896 1910 889.381C1910 891.866 1912.01 893.881 1914.5 893.881Z",
    fill: "#8FFFFC"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter45_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1722.02 742.461C1724.51 742.461 1726.52 740.446 1726.52 737.961C1726.52 735.476 1724.51 733.461 1722.02 733.461C1719.53 733.461 1717.52 735.476 1717.52 737.961C1717.52 740.446 1719.53 742.461 1722.02 742.461Z",
    fill: "#8FFFFC"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter46_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1827.17 708.859C1829.66 708.859 1831.67 706.845 1831.67 704.359C1831.67 701.874 1829.66 699.859 1827.17 699.859C1824.68 699.859 1822.67 701.874 1822.67 704.359C1822.67 706.845 1824.68 708.859 1827.17 708.859Z",
    fill: "#8FFFFC"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter47_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1914.89 787.4C1917.38 787.4 1919.39 785.386 1919.39 782.9C1919.39 780.415 1917.38 778.4 1914.89 778.4C1912.4 778.4 1910.39 780.415 1910.39 782.9C1910.39 785.386 1912.4 787.4 1914.89 787.4Z",
    fill: "#8FFFFC"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter48_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M481.25 588.641C483.735 588.641 485.75 586.626 485.75 584.141C485.75 581.655 483.735 579.641 481.25 579.641C478.765 579.641 476.75 581.655 476.75 584.141C476.75 586.626 478.765 588.641 481.25 588.641Z",
    fill: "#8FFFFC"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter49_d_3572_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M538.32 603.51C540.805 603.51 542.82 601.495 542.82 599.01C542.82 596.524 540.805 594.51 538.32 594.51C535.835 594.51 533.82 596.524 533.82 599.01C533.82 601.495 535.835 603.51 538.32 603.51Z",
    fill: "#8FFFFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3572_6",
    x: -97.03,
    y: 0,
    width: 2065.27,
    height: 1019.96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.788235 0 0 0 0 1 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3572_6",
    x: 1290.79,
    y: 690.301,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3572_6",
    x: 1415.4,
    y: 676.34,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_3572_6",
    x: 1537.52,
    y: 680.98,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_3572_6",
    x: 1553.63,
    y: 691.439,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_3572_6",
    x: 1660.93,
    y: 688.24,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_3572_6",
    x: 1625.88,
    y: 673.041,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_3572_6",
    x: 1683.88,
    y: 698.33,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_3572_6",
    x: 743.94,
    y: 809.471,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_3572_6",
    x: 913.75,
    y: 936.02,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_3572_6",
    x: 1190.37,
    y: 832.48,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_3572_6",
    x: 984.27,
    y: 988.871,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_3572_6",
    x: 1222.71,
    y: 988.23,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_3572_6",
    x: 1170.43,
    y: 734.211,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_d_3572_6",
    x: 636.64,
    y: 976.9,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_d_3572_6",
    x: 491.06,
    y: 623.791,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d_3572_6",
    x: 247.56,
    y: 851.77,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_d_3572_6",
    x: 903.35,
    y: 198.52,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_d_3572_6",
    x: 1086.15,
    y: 337.24,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_d_3572_6",
    x: 1128.84,
    y: 268.311,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_d_3572_6",
    x: 1061.24,
    y: 215.52,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_d_3572_6",
    x: 964.79,
    y: 140.65,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_d_3572_6",
    x: 1075.7,
    y: 35.8711,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_d_3572_6",
    x: 1185.37,
    y: 132.68,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_d_3572_6",
    x: 1032.24,
    y: 76.75,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_d_3572_6",
    x: 816.98,
    y: 24.9199,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_d_3572_6",
    x: 1020.47,
    y: 21.3301,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_d_3572_6",
    x: 1056.51,
    y: 18.9707,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_d_3572_6",
    x: 1097.92,
    y: 15.4609,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_d_3572_6",
    x: 1258.98,
    y: 19.9297,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_d_3572_6",
    x: 1231.73,
    y: 174.76,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_d_3572_6",
    x: 33.3101,
    y: 49.9297,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter32_d_3572_6",
    x: -6.1001,
    y: 21.9004,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter33_d_3572_6",
    x: 259.54,
    y: 20.1895,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter34_d_3572_6",
    x: 277.12,
    y: 63.3809,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter35_d_3572_6",
    x: -6.51001,
    y: 626.121,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter36_d_3572_6",
    x: 402.96,
    y: 989.699,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter37_d_3572_6",
    x: 101.66,
    y: 990.23,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter38_d_3572_6",
    x: 1594.84,
    y: 22.9492,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter39_d_3572_6",
    x: 1598.85,
    y: 105.49,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter40_d_3572_6",
    x: 1906.36,
    y: 23.9297,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter41_d_3572_6",
    x: 1764.97,
    y: 207.791,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter42_d_3572_6",
    x: 1627.24,
    y: 770.779,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter43_d_3572_6",
    x: 1636.8,
    y: 994.699,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter44_d_3572_6",
    x: 1904,
    y: 878.881,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter45_d_3572_6",
    x: 1711.52,
    y: 727.461,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter46_d_3572_6",
    x: 1816.67,
    y: 693.859,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter47_d_3572_6",
    x: 1904.39,
    y: 772.4,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter48_d_3572_6",
    x: 470.75,
    y: 573.641,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter49_d_3572_6",
    x: 527.82,
    y: 588.51,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3572_6",
    x1: 848.59,
    y1: -176.578,
    x2: 2391.53,
    y2: 59.9887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3572_6",
    x1: -2761.57,
    y1: -3380.7,
    x2: -2757.49,
    y2: -3380.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3572_6",
    x1: -213.196,
    y1: 472.274,
    x2: 191.45,
    y2: 1147.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3572_6",
    x1: 1513.89,
    y1: -273.509,
    x2: 227.274,
    y2: 683.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3572_6",
    x1: 157.211,
    y1: -185.531,
    x2: 295.721,
    y2: 1051.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3572_6",
    x1: 157.032,
    y1: -146.462,
    x2: 295.542,
    y2: 1090.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3572_6",
    x1: 1595.43,
    y1: -190.592,
    x2: 1596.88,
    y2: 1015.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3572_6",
    x1: 1595.43,
    y1: -190.591,
    x2: 1596.88,
    y2: 1015.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3572_6",
    x1: -714.605,
    y1: 1738.98,
    x2: -1327.28,
    y2: 339.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3572_6",
    x1: -757.619,
    y1: 1818.48,
    x2: -1391.32,
    y2: 370.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3572_6",
    x1: 2240.98,
    y1: 1147.06,
    x2: 2083.19,
    y2: -221.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3572_6",
    x1: 2240.98,
    y1: 1147.06,
    x2: 2083.19,
    y2: -221.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3572_6",
    x1: 774.198,
    y1: -751.473,
    x2: 667.373,
    y2: 1523.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3572_6",
    x1: 709.791,
    y1: -754.497,
    x2: 602.965,
    y2: 1520.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3572_6",
    x1: -3417.9,
    y1: -1761.27,
    x2: -2297.75,
    y2: 3771.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3572_6",
    x1: -4482.49,
    y1: -2799.12,
    x2: -4009.92,
    y2: 3186.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3572_6",
    x1: 752.149,
    y1: 663.835,
    x2: 1989.24,
    y2: 448.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3572_6",
    x1: 663.931,
    y1: 846.103,
    x2: 1142.79,
    y2: 1264.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundVectors);
export default __webpack_public_path__ + "static/media/background-vectors.2ea85e55f30742610d88bd8743580a75.svg";
export { ForwardRef as ReactComponent };